import countries from "world-countries";

/**
 * Static country/dial-code list, computed once at module load - not fetched.
 * This is what @simplifyhq/simplify-ui-reusables' FormInputPhoneNumber (and
 * its duplicate in src/components/ui/Form/FormInputPhoneNumber) get wrong:
 * both fetch("https://restcountries.com/...") on every mount, with no static
 * fallback, so a slow/blocked request renders as an empty, broken field.
 *
 * Dial code: use idd.root alone when a country shares it with many others
 * (e.g. NANP: US/Canada/Caribbean all root "+1" with 100s of area-code
 * suffixes) - combining root+suffixes[0] naively (what the buggy fetch code
 * did) produces nonsense like "+1201" for the United States. Only combine
 * root+suffix when there's exactly one suffix, which is how restcountries
 * disambiguates genuinely distinct dial codes that happen to share a root.
 */
export const countryCodes = countries
  .filter((country) => country.idd?.root)
  .map((country) => {
    const { root, suffixes = [] } = country.idd;
    const dialCode = suffixes.length === 1 ? `${root}${suffixes[0]}` : root;

    return {
      dialCode,
      name: country.name.common,
      flag: country.flag,
      iso2: country.cca2,
    };
  })
  .sort((a, b) => a.name.localeCompare(b.name));
